<template>
    <div class="eval-popup" v-if="visible">
        <div class="eval-popup__overlay"></div>
        <div class="eval-popup__wrapper">
            <div class="eval-popup__info">
                <img class="eval-popup__img" src='/images/eval-popup.png'>
                <div class='eval-popup__lead'>Вы зашли на страницы журнала «Сибирская нефть». Пожалуйста, ответьте на несколько вопросов. Это поможет нам стать лучше, полезнее и интереснее для Вас!</div>
                <a
                    href="https://linkis.ru/a/3b2d0589-f1a0-4889-b410-bb7717650775/"
                    target="_blank"
                    class="btn btn-eval"
                    @click="submit"
                    data-target="eval1"
                    data-label="eval1"
                    data-category="eval"
                    >Принять участие в опросе</a>
            </div>
            <div class="eval-popup__close" @click="close"></div>
        </div>
    </div>
</template>

<script>
import { targetAnalytics } from '@/utils/util.js'
const cookie = require('cookie_js')

export default {
    name: 'eval-popup',
    data () {
        return {
            visible: false,
            targetAnalytics
        }
    },
    mounted () {
        let self = this
        setTimeout(
            function(){
                self.visible = !cookie.get('eval_popup')
            }, 30000)
        
    },
    methods: {
        submit (event) {
            this.visible = false
            this.targetAnalytics(event)
            cookie.set({
                'eval_popup': true
            }, {
                domain: '.' + location.host,
                path: '/',
                expires: 365
            })
        },
        close () {
            this.visible = false
            cookie.set({
                'eval_popup': true
            }, {
                domain: '.' + location.host,
                path: '/'
            })
        }
    }
}
</script>

<style src="./eval-popup.scss"></style>



// WEBPACK FOOTER //
// frontend/components/eval-popup/eval-popup.vue